import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=436ade80&scoped=true&"
import script from "./MediaImage.vue?vue&type=script&lang=js&"
export * from "./MediaImage.vue?vue&type=script&lang=js&"
import style0 from "./MediaImage.vue?vue&type=style&index=0&id=436ade80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ade80",
  null
  
)

export default component.exports